import { axios } from "lib/axios";

export const resendOtp = data => {
  return axios.post(`/auth/resend_otp`, data);
};
